export default {
    apiGateway: {
      REGION: import.meta.env.VITE_AWS_REGION,
      URL: import.meta.env.VITE_LOCMAN_UI_URL,
      QUERIES_URL: import.meta.env.VITE_LOCMAN_QUERIES_URL
    },
    cognito: {
      REGION: import.meta.env.VITE_AWS_COGNITO_REGION,
      USER_POOL_ID: import.meta.env.VITE_USER_POOL_ID,
      APP_CLIENT_ID: import.meta.env.VITE_APP_CLIENT_ID,
      IDENTITY_POOL_ID: import.meta.env.VITE_IDENTITY_POOL_ID
    }
  };